module.exports = __webpack_public_path__ + "img/img1_8.d3dc5ca0.jpeg";